import {GET_LOCATION_FAILURE, GET_LOCATION_SUCCESS} from 'new-constants/geolocation.constants';
import {
	ASK_LOCATION_PERMISSION_SUCCESS,
	LOAD_LOCATION_PERMISSION_STATUS_SUCCESS,
} from 'new-constants/permission.constants';
import {NativePermissionStatuses} from 'new-constants/common.constants';
import {LocationState} from './location.reducer.types';

const initialState: LocationState = {
	currentLocation: null,
};

export const locationReducer = (previousState = initialState, action): LocationState => {
	switch (action && action.type) {
		case GET_LOCATION_SUCCESS:
			if (action.latitude && action.longitude) {
				return {
					...previousState,
					currentLocation: {
						latitude: action.latitude,
						longitude: action.longitude,
						timestamp: action.timestamp,
					},
				};
			}

			return previousState;

			break;

		case GET_LOCATION_FAILURE:
			return {
				...previousState,
				currentLocation: null,
			};
			break;

		case ASK_LOCATION_PERMISSION_SUCCESS:
		case LOAD_LOCATION_PERMISSION_STATUS_SUCCESS:
			if (
				action.status !== NativePermissionStatuses.GRANTED &&
				action.status !== NativePermissionStatuses.GRANTED_WHEN_IN_USE
			) {
				return {
					...previousState,
					currentLocation: null,
				};
			}

			return previousState;
			break;
		default:
			return previousState;
	}
};
